import PhotoSwipeLightbox from './photoswipe-lightbox.esm.js';
document.addEventListener('DOMContentLoaded', function (){
    const lightbox = new PhotoSwipeLightbox({
        // may select multiple "galleries"
        gallery: '.prod-carousel-container',

        // Elements within gallery (slides)
        children: 'a.product__modal-opener--image',
        mainClass: 'main-prod-lightbox--img',

        // setup PhotoSwipe Core dynamic import
        pswpModule: () => import('./photoswipe.esm.js')
    });
    lightbox.init();
});

function initMediaLightbox(){
    const lightbox = new PhotoSwipeLightbox({
        // may select multiple "galleries"
        gallery: '.prod-carousel-container',

        // Elements within gallery (slides)
        children: 'a.product__modal-opener--image',

        // setup PhotoSwipe Core dynamic import
        pswpModule: () => import('./photoswipe.esm.js')
    });
    lightbox.init();
}
window.initMediaLightbox = initMediaLightbox;